
import React from "react";
import img1 from "./imgs/C1.jpg";
// import img2 from "./imgs/0C1.jpg"
import img3 from "./imgs/14.M-Cure 1-c.jpg"
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/C1.jpg";
import img2en from "./imgs/MC1.jpeg"
import img3en from "./imgs/14-M-Cure 1.jpg"

export function MCure1() {

    const lang = LOCALES_HELPER.getLan();
    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img3} id="1"/>
                    <img className="product-img" src={img1}/>
                </>
                : <>
                    <img className="product-img" src={img1en}/>
                    <img className="product-img" src={img2en}/>
                    <img className="product-img" src={img3en}/>
                </>
            }
        </>
    )
}